import { combineReducers } from 'redux'
import { persistReducer } from 'redux-persist'
import LocalStorage from 'redux-persist/lib/storage'

import brandCurationTaskReducer from './brand-curation-task-reducer'
import brandCurationTasksReducer from './brand-curation-tasks-reducer'

export default combineReducers({
  brandCurationTasks: persistReducer(
    {
      key: 'brandCurationTasks',
      storage: LocalStorage,
      whitelist: ['persistedFilters'],
    },
    brandCurationTasksReducer,
  ),
  brandCurationTask: brandCurationTaskReducer,
})
